export const request = <T>(url: string, headers: HeadersInit = {}, body: T) => {
  return fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body),
  })
}
